import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { VersionsEditCard } from "./edit_card";

const client = "instit-quantilia";
const table_name = "versions";

export const VersionsCard = () => {
  const { id } = useParams<{ id: string }>();
  const parsedId = Number(id);

  if (!id || Number.isNaN(parsedId)) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <VersionsEditCard
          id={parsedId}
          client={client}
          table_name={table_name}
        />
        <AuditCard
          id={parsedId}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
